import { createVNode as i, mergeProps as n } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/SignFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (t, e) => {
  const a = {
    ...t,
    ...e.attrs
  };
  return i(d, n(a, {
    icon: o
  }), null);
};
r.displayName = "SignFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
